import { render, staticRenderFns } from "./TotalAnalysis.vue?vue&type=template&id=b7d3a048&scoped=true"
import script from "./TotalAnalysis.vue?vue&type=script&lang=js"
export * from "./TotalAnalysis.vue?vue&type=script&lang=js"
import style0 from "./TotalAnalysis.vue?vue&type=style&index=0&id=b7d3a048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d3a048",
  null
  
)

export default component.exports